// eslint-disable-next-line @typescript-eslint/no-explicit-any
type anyObject = any;

export const createSearchByObject = <T>(config: T | { [searchKey: string]: anyObject }): URLSearchParams => {
    const search = new URLSearchParams();
    if (config) {
        const configKeys = Object.keys(config);

        configKeys.forEach(key => {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const value = (config as any)[key];
            if (value) {
                if (value !== null && typeof value === 'object' && !Array.isArray(value)) {
                    const names = recursiveGetKeyNames(value, {}, key);
                    Object.keys(names).map(deepKey => search.set(deepKey, getStringOfValue(names[deepKey])));

                    // Empty arrays are handled as no value
                } else if (!Array.isArray(value) || (Array.isArray(value) && value.length > 0)) {
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    search.set(key, getStringOfValue((config as any)[key]));
                }
            }
        });
    }

    return search;
};

const recursiveGetKeyNames = (object: anyObject, collection: anyObject, previous: string) => {
    Object.keys(object).forEach(key => {
        const value = object[key];
        if (value !== null && value !== undefined) {
            const newKey = previous + '[' + key + ']';
            if (value !== null && typeof value === 'object' && !Array.isArray(value)) {
                recursiveGetKeyNames(value, collection, newKey);
            } else {
                collection[newKey] = value;
            }
        }
    });

    return collection;
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const getStringOfValue = (value: any) => {
    if (Array.isArray(value)) {
        return value.join(',');
    }

    return value.toString();
};
